// window.__RENDERER_NAME is defined in the global scope of the electron renderer processes.
// In any other context, it _should_ be undefined.
export const WINDOW_NAME = typeof window !== 'undefined' ? window.__RENDERER_NAME : undefined
export const isInteractiveRenderer = WINDOW_NAME === 'overlay'
